import setAdditionalMetaOptions from '@/js/common/Domain/Service/setAdditionalMetaOptions';
import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => requestService({
    url: `${window.appConfig.apiGatewayUrl}/frontend/tours`,
    data: {
        limit: 10000,
        dc: window.appConfig.showcaseDC,
        ...tourCriteriaForTourRequest,
        ...setAdditionalMetaOptions(),
        sections: ['hotels', 'countries', 'firstPaymentDefinitions', 'operators', 'sortRate', 'hotelPhotos', 'offerPromo'],
    },
}, callback);
